<template>
  <div>
    <div class="c-base-transaction-details__price">
      <div class="c-base-transaction-details__icon">
        <base-icon width="24" height="24" :name="icon" />
      </div>
      <div class="c-base-transaction-details__amount">
        {{ transaction.amount | currency }}
      </div>

      <p
        v-if="transaction.details.partner === 'starkbank'"
        class="c-base-transaction-details__logo--pix"
      >
        PIX
      </p>
      <p v-else class="c-base-transaction-details__logo--paypal">PayPal</p>

      <p class="c-base-transaction-details__category">
        <strong>Estorno de transferência por {{ getNamePartner() }}</strong>
        <br />
        <small>Realizada em {{ transaction.created_at | date }}</small>
      </p>
    </div>
    <div class="c-base-transaction-details__body">
      <div
        class="columns is-mobile is-vcentered is-gapless is-multiline margin-bottom"
      >
        <div class="column is-half">
          <p class="is-size-6">
            <strong>Valor estornado</strong>
          </p>
        </div>
        <div class="column is-half has-text-right">
          <strong class="has-text-support is-size-6">
            {{ transaction.amount | currency }}
          </strong>
        </div>
      </div>

      <a
        v-if="referenceTransaction"
        @click="emitReferenceTransaction"
        class="columns is-vcentered is-mobile is-gapless is-multiline margin-bottom"
        href="#"
      >
        <div class="column">
          <p class="has-text-black margin-bottom">
            Confira seus dados na sua conta {{ getNamePartner() }}<br />
            <strong v-if="getNamePartner() === 'PayPal'">{{
              transaction.details.email
            }}</strong>
            <strong v-else>
              {{ transaction.details.bank_account.owner_full_name }}<br />
              <span v-if="transaction.details.bank_account?.bank?.name">
                {{ transaction.details.bank_account.owner_cpf }} ·
                {{ transaction.details.bank_account.bank.name }}
              </span>
              <span v-else>
                {{ transaction.details.bank_account.owner_cpf }}
              </span>
            </strong>
          </p>
          <p class="has-text-black margin-bottom">
            Referente à transferência para conta {{ getNamePartner() }}
            <br />
          </p>
          <p class="has-text-black">
            Em {{ referenceTransaction.created_at | date }}
          </p>
        </div>
        <div class="column has-text-right is-1">
          <base-icon
            width="24px"
            height="24px"
            name="painel/arrow-right-icon"
            class="has-text-grey-dark"
          />
        </div>
      </a>

      <div class="c-base-transaction-details__footer">
        <p class="is-size-6">
          Código da transação:<br />
          <strong>{{ transaction.transaction_id }}</strong>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTransactionDetailsMixin from '@/mixins/BaseTransactionDetailsMixin'

import WalletApi from '@/lib/api/Wallet'

export default {
  mixins: [BaseTransactionDetailsMixin],

  props: {
    transaction: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    transactions() {
      return this.$store.state.wallet.transactions
    },

    transactionsLoadeds: {
      get() {
        return this.$store.state.wallet.transactionsLoadeds
      },
      set(payload) {
        this.$store.dispatch('setTransactionsLoadeds', payload)
      },
    },
  },

  data() {
    return {
      referenceTransaction: null,
    }
  },

  created() {
    this.getReferenceTransaction()
  },

  methods: {
    getNamePartner() {
      if (
        this.transaction.details.partner &&
        this.transaction.details.partner === 'starkbank'
      ) {
        return 'PIX'
      } else {
        return 'PayPal'
      }
    },

    getReferenceTransaction() {
      const reference = this.transactionsLoadeds.find(
        (transaction) =>
          transaction.transaction_id === this.transaction.reference_id
      )
      if (reference) {
        this.referenceTransaction = reference
        return
      }
      const walletApi = new WalletApi(this.logonToken)
      walletApi
        .getTransaction(this.transaction.reference_id)
        .then((response) => {
          this.referenceTransaction = response.data.data
          this.transactionsLoadeds = this.transactionsLoadeds.concat(
            this.referenceTransaction
          )
          this.referenceTransaction
        })
        .catch(null)
    },

    emitReferenceTransaction() {
      this.$emit('open-reference')
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-transaction-details {
  &__logo {
    &--pix {
      font-size: 12px;
      line-height: 1.33;
      font-weight: bold;
      color: $supportdark;
      padding: 15px 10px 4px;
    }

    &--paypal {
      font-size: 12px;
      line-height: 1.33;
      font-weight: bold;
      color: $paypal-color;
      padding: 15px 10px 4px;
    }
  }
}
</style>
